import { useTableColumns } from '../../../../hooks/table/useTableColumns/useTableColumns';
import { useTableColumnWithFiltersAndSorters } from '../../../../hooks/useTableColumnWithFiltersAndSorters/useTableColumnWithFiltersAndSorters';
import { createPatientColumns } from '../../../patient/component/PatientsTableComponent/columns';
import { PatientsTableComponent } from '../../../patient/component/PatientsTableComponent/PatientsTableComponent';
import { PatientTableProps } from '../../type';

export interface AllPatientsTableComponentProps extends PatientTableProps {
}

export const AllPatientsTableComponent = ({
  totalSize,
  filters,
  sorters,
  ...props
}: AllPatientsTableComponentProps) => {
  const columns = useTableColumns(
    createPatientColumns,
    [{ name: 'name', args: ['ascend'] }, 'age', 'gender', 'clinic', 'provider', 'mrn', 'status', 'program'],
  );

  const columnsWithFilters = useTableColumnWithFiltersAndSorters({
    columns,
    filters,
    sorters: sorters || { columnKey: 'id', order: 'ascend' },
  });

  return (
    <PatientsTableComponent
      totalSize={totalSize}
      columns={columnsWithFilters}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
};
